// extracted by mini-css-extract-plugin
export default {"answerDescription":"AnswerDescription_answerDescription__S6No9","answerDisplay":"AnswerDescription_answerDisplay__R-SxJ","textAnswer":"AnswerDescription_textAnswer__rRKn4"};